<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>

        <vs-spacer/>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ user_displayName }}</p>
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <!--              <vs-avatar :text="user_displayName"></vs-avatar>-->
              <img
                v-if="activeUserImg"
                key="localImg"
                :src="require('@/assets/images/portrait/small/user-cicle.png')"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown nav-dropdown-user" id="header-dropdown-menu-user">
              <ul style="min-width: 9rem">
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="goToMyAccount">
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Profile}}</span>
                </li>
                <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"><feather-icon icon="MailIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Inbox</span></li>
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"><feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Tasks</span></li>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"><feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"></feather-icon> <span class="ml-2">Chat</span></li>-->
                <vs-divider class="m-1"></vs-divider>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changePassword">
                  <feather-icon icon="KeyIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Change_Password}}</span>
                </li>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="goToAskToAnalyst">
                  <feather-icon icon="KeyIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Ask_To_Analyst}}</span>
                </li>
                <vs-divider class="m-1"></vs-divider>
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                  <vs-switch v-model="themeMode" vs-value="dark" color="#5a3cc4"/>
                  <span class="ml-2">Tema escuro</span>
                </li>
                <vs-divider class="m-1"></vs-divider>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Logout}}</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
  import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import draggable from "vuedraggable";
  import localStorageHelper from "../../../helpers/local-storage-helper";
  import authService from "../../../providers/authService";
  import AppConstants from '../../../appConstants';

  export default {
    name: "the-navbar",
    props: {
      navbarColor: {
        type: String,
        default: "#fff"
      }
    },
    data() {
      return {
        navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
        searchQuery: "",
        showFullSearch: false,
        unreadNotifications: [],
        settings: {
          // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: 0.6
        },
        autoFocusSearch: false,
        showBookmarkPagesDropdown: false,
      };
    },
    watch: {
      $route() {
        if (this.showBookmarkPagesDropdown)
          this.showBookmarkPagesDropdown = false;
      }
    },
    computed: {
      themeMode: {
        get() {
          return this.$store.state.theme === AppConstants.THEME.DARK;
        },
        set(val) {
          let theme;
          if (val) {
            theme = AppConstants.THEME.DARK;
          } else {
            theme = AppConstants.THEME.LIGHT;
          }
          localStorageHelper.updateTheme(theme);
        }
      },
      navbarColorLocal() {
        return this.$store.state.theme === AppConstants.THEME.DARK ? "#10163a" : this.navbarColor;
      },
      // HELPER
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth;
      },
      windowWidth() {
        return this.$store.state.windowWidth;
      },

      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth == "default") return "navbar-default";
        else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
        else if (this.verticalNavMenuWidth) return "navbar-full";
      },

      // BOOKMARK & SEARCH
      data() {
        return this.$store.state.navbarSearchAndPinList;
      },
      starredPages() {
        return this.$store.state.starredPages;
      },
      starredPagesLimited: {
        get() {
          return this.starredPages.slice(0, 10);
        },
        set(list) {
          this.$store.dispatch("arrangeStarredPagesLimited", list);
        }
      },
      starredPagesMore: {
        get() {
          return this.starredPages.slice(10);
        },
        set(list) {
          this.$store.dispatch("arrangeStarredPagesMore", list);
        }
      },

      // PROFILE
      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },
      user_displayName() {
        return this.activeUserInfo.nome;
        // return LocalStorageHelper.getCurrentUser().username || "";
      },
      activeUserImg() {
        // return require('@/assets/images/portrait/small/user-cicle.png');
        return "user-cicle.png";
        // return this.$store.state.AppActiveUser.photoURL;
      }
    },
    methods: {
      updateLocale(locale) {
        this.$i18n.locale = locale;
      },
      logout() {
        authService.logout();
      },
      showSidebar() {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      },
      selected(item) {
        this.$router.push(item.url).catch(() => {
        });
        this.showFullSearch = false;
      },
      actionClicked(item) {
        // e.stopPropogation();
        this.$store.dispatch("updateStarredPage", {
          index: item.index,
          val: !item.highlightAction
        });
      },
      showNavbarSearch() {
        this.showFullSearch = true;
      },
      showSearchbar() {
        this.showFullSearch = true;
      },
      elapsedTime(startTime) {
        let x = new Date(startTime);
        let now = new Date();
        var timeDiff = now - x;
        timeDiff /= 1000;

        var seconds = Math.round(timeDiff);
        timeDiff = Math.floor(timeDiff / 60);

        var minutes = Math.round(timeDiff % 60);
        timeDiff = Math.floor(timeDiff / 60);

        var hours = Math.round(timeDiff % 24);
        timeDiff = Math.floor(timeDiff / 24);

        var days = Math.round(timeDiff % 365);
        timeDiff = Math.floor(timeDiff / 365);

        var years = timeDiff;

        if (years > 0) {
          return years + (years > 1 ? " Years " : " Year ") + "ago";
        } else if (days > 0) {
          return days + (days > 1 ? " Days " : " Day ") + "ago";
        } else if (hours > 0) {
          return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
        } else if (minutes > 0) {
          return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
        } else if (seconds > 0) {
          return seconds + (seconds > 1 ? " sec ago" : "just now");
        }

        return "Just Now";
      },
      outside: function () {
        this.showBookmarkPagesDropdown = false;
      },

      // Method for creating dummy notification time
      randomDate({hr, min, sec}) {
        let date = new Date();

        if (hr) date.setHours(date.getHours() - hr);
        if (min) date.setMinutes(date.getMinutes() - min);
        if (sec) date.setSeconds(date.getSeconds() - sec);

        return date;
      },
      getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale == "EnEu") return {flag: "us", lang: "English"};
        else if (locale == "PtBr") return {flag: "br", lang: "Portuguese"};
        else if (locale == "EsEs") return {flag: "es", lang: "Spanish"};
        else if (locale == "EsAr") return {flag: "ar", lang: "Argentina"};
        else if (locale == "PtPt") return {flag: "pt", lang: "Portuguese"};
      },
      changePassword() {
        this.$router.push(AppConstants.NAVIGATION_PAGE_CHANGE_PASSWORD);
      },
      goToMyAccount() {
        console.log('my account')
        this.$router.push(AppConstants.NAVIGATION_PAGE_MY_ACCOUNT);
      },
      goToAskToAnalyst() {
        this.$router.push(AppConstants.NAVIGATION_PAGE_ASK_TO_ANALYST);
      },
      closeMenuUserDropdown() {
        const menu = document.getElementById('header-dropdown-menu-user');
        menu.style.display = 'none';
      }
    },
    directives: {
      "click-outside": {
        bind: function (el, binding) {
          const bubble = binding.modifiers.bubble;
          const handler = e => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e);
            }
          };
          el.__vueClickOutside__ = handler;
          document.addEventListener("click", handler);
        },

        unbind: function (el) {
          document.removeEventListener("click", el.__vueClickOutside__);
          el.__vueClickOutside__ = null;
        }
      }
    },
    components: {
      VxAutoSuggest,
      VuePerfectScrollbar,
      draggable
    }
  };
</script>
<style>
  .nav-dropdown-user {
    min-width: 200px;
  }
</style>
